<template>

  <div class="sidemenu">
    <router-link
      :to="{ name: 'MyTraining' }"
      :class="[routeName=='MyTraining'?'item menu-setting active':'item menu-setting']"
    >
      <i class="icon-my-class"></i> 
      <span class="text">我的培训</span>
      
    </router-link>

    <router-link
      :to="{ name: 'MyCollection' }"
      :class="[routeName=='MyCollection'?'item menu-setting active':'item menu-setting']"
    >
      <i class="icon-my-recourse"></i> 
      <span class="text">我的收藏</span>
    </router-link>

    <router-link
      :to="{ name: 'MyCourse' }"
      :class="[routeName=='MyCourse'?'item menu-setting active':'item menu-setting']"
    >
      <i class="icon-my-course"></i>
      <span class="text">我的课程</span> 
    </router-link>

    <router-link
      :to="{ name: 'MyLive' }"
      :class="[routeName=='MyLive'?'item menu-setting active':'item menu-setting']"
    >
      <i class="icon-my-shouc"></i> 
      <span class="text">我的直播</span>
    </router-link>

    <router-link
      :to="{ name: 'MyQuestions' }"
      :class="[routeName=='MyQuestions'?'item menu-setting active':'item menu-setting']"
    >
      <i class="icon-my-question"></i> 
      <span class="text">我的问答</span>
    </router-link>

    <router-link
      :to="{ name: 'MyAchievements' }"
      :class="[routeName=='MyAchievements'?'item menu-setting active':'item menu-setting']"
    >
      <i class="icon-my-course"></i> 
      <span class="text">我的成果</span>
    </router-link>

    <router-link
      :to="{ name: 'MyAccountSetting'}"
      :class="[routeName=='MyAccountSetting'?'item menu-setting active':'item menu-setting']"
    >
      <i class="icon-my-setting"></i> 
      <span class="text">资料设置</span>
    </router-link>

    <img src="/Images/img2018/usercenter-logo.png" />
  </div>
</template>
<script>
export default {
  name: "",
  methods: {
    showListClick(objc) {
      this.showList = objc;
    },
  },
  computed: {},
  data() {
    return {
      showList: 0,
      routeName: "MyTraining",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.routeName = route.name;
      },
      immediate: true,
    },
  },
};
</script>